import type { BetSegmentsIcons, BetSegmentsSize } from "../../BetSegments.types";

export enum SelectionSegmentOrientation {
  COLUMN = "column",
  ROW = "row",
}

export type SelectionSegmentProps = {
  term: string;
  value: string;
  rawValue?: number;
  previousValue?: string;
  detail?: string;
  icon?: BetSegmentsIcons;
  lastElement?: boolean;
  size?: BetSegmentsSize;
  isOdds?: boolean;
  isOddsBoosted?: boolean;
  neutralPnl?: boolean;
  className?: string;
  orientation?: SelectionSegmentOrientation;
};
